export default __webpack_public_path__ + "static/media/newlogo-white3.2c2a6b48.png";